import { useState, useEffect, useCallback } from 'react';

const PERMISOS_ADMIN = [
    'ver_dashboard', 'ver_kpis',
    'ver_ordenes', 'crear_ordenes', 'editar_ordenes', 'eliminar_ordenes',
    'tomar_ordenes', 'completar_ordenes', 'facturar_ordenes', 'cancelar_ordenes',
    'ver_clientes', 'crear_clientes', 'editar_clientes', 'eliminar_clientes',
    'ver_vehiculos', 'crear_vehiculos', 'editar_vehiculos', 'eliminar_vehiculos',
    'ver_inventario', 'gestionar_inventario',
    'ver_reportes', 'exportar_reportes',
    'gestionar_roles', 'gestionar_usuarios', 'configurar_campos',
];

export function useOrdenesPermisos() {
    const [permisos, setPermisos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [esAdmin, setEsAdmin] = useState(false);

    useEffect(() => {
        const loadPermisos = async () => {
            try {
                const userStr = localStorage.getItem('user');
                if (!userStr) {
                    setPermisos([]);
                    setLoading(false);
                    return;
                }

                const user = JSON.parse(userStr);
                
                // Si es superadmin o admin, tiene todos los permisos
                if (user?.rol === 'superadmin' || user?.rol === 'admin') {
                    setEsAdmin(true);
                    setPermisos(PERMISOS_ADMIN);
                } else {
                    // Para otros roles, buscar permisos específicos del módulo
                    // Por ahora, dar permisos básicos a todos los usuarios autenticados
                    setPermisos(['ver_dashboard', 'ver_ordenes', 'ver_clientes', 'ver_vehiculos']);
                }
            } catch (error) {
                console.error('Error loading permisos:', error);
                setPermisos([]);
            } finally {
                setLoading(false);
            }
        };

        loadPermisos();
    }, []);

    const tienePermiso = useCallback((permiso) => {
        if (esAdmin) return true;
        return permisos.includes(permiso);
    }, [permisos, esAdmin]);

    const tieneAlgunPermiso = useCallback((permisosRequeridos) => {
        if (esAdmin) return true;
        return permisosRequeridos.some(p => permisos.includes(p));
    }, [permisos, esAdmin]);

    const tieneTodosPermisos = useCallback((permisosRequeridos) => {
        if (esAdmin) return true;
        return permisosRequeridos.every(p => permisos.includes(p));
    }, [permisos, esAdmin]);

    return {
        permisos,
        loading,
        esAdmin,
        tienePermiso,
        tieneAlgunPermiso,
        tieneTodosPermisos,
    };
}

export default useOrdenesPermisos;
